export default "__VITE_ASSET__BeudW4rB__"